import React from 'react';
import { getTypeformUrl } from '../utils/cookies';
export const Header = () => {
  const handleScheduleCall = e => {
    e.preventDefault();
    window.location.href = getTypeformUrl();
  };
  return <header className="absolute top-0 left-0 right-0 z-50 bg-transparent py-4" data-id="element-336">
      <div className="container mx-auto px-4 md:px-8 flex justify-between items-center" data-id="element-337">
        <div className="flex items-center" data-id="element-338">
          <img src="https://cdn.magicpatterns.com/uploads/cGmqASMaWsiDkJPn4a1Kiz/logo_w_n_(1).svg" alt="Ikigai Real Estate" className="h-10 md:h-14" data-id="element-339" />
        </div>

        <nav className="flex items-center" data-id="element-340">
          <a href="#" onClick={handleScheduleCall} className="btn-gold px-3 py-1.5 md:px-6 md:py-2.5 rounded-md font-semibold text-[11px] md:text-sm whitespace-nowrap" data-id="element-341">
            <span className="hidden md:inline" data-id="element-342">Book a Free Strategy Call</span>
            <span className="md:hidden" data-id="element-343">Book a Call</span>
          </a>
        </nav>
      </div>
    </header>;
};